import React from 'react';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import validator from 'validator';
import { useTranslation } from 'react-i18next';

import MainComponent from '../../commons/main/mainComponent';

import './forgotView.css';

const ForgotView = ({ success, message, handleInputChange, handleForgot }) => {
    const { t } = useTranslation();

    return (
        <div className="forgotview-container">
            <MainComponent>
                <h3 className="text-center">{t('forgot.title')}</h3>
                <p className="text-center">{t('forgot.introResetLink')}</p>
                <p className="text-center">{t('forgot.introLostEmail')}</p>
                {message ? (
                    <Alert variant={!success ? 'danger' : 'success'}>
                        {t(message.key, message.params)}
                    </Alert>
                ) : null}
                <ValidationForm
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleForgot(e);
                    }}
                >
                    <Form.Group>
                        <TextInput
                            name="email"
                            id="email"
                            errorMessage={{
                                required: t('forgot.emailRequired'),
                                validator: t('forgot.emailInvalid'),
                            }}
                            validator={validator.isEmail}
                            onChange={handleInputChange}
                            placeholder={t('forgot.emailPlaceholder')}
                        />
                    </Form.Group>
                    <Button type="submit" variant="success">
                        {t('forgot.submit')}
                    </Button>
                </ValidationForm>
                <hr />
                <div className="btm-links">
                    <p>
                        <Link to="/">{t('common.back')}</Link>
                    </p>
                </div>
            </MainComponent>
        </div>
    );
};

export default ForgotView;
